
function LoadingTemplate({loading}) {
 

  if (loading) {
    return (<div className="absolute top-0 s w-full flex justify-center	items-center	h-screen">Loading....</div>)
   }
}

export default LoadingTemplate;

